import InterWebviewBridge, { WbEnvironments } from '@interco/inter-webview-bridge'

/**
 * True when the bundle is production and the host is a regular browser (not the Inter app webview).
 */
export const isBlockedBrowserProduction = (): boolean =>
  process.env.REACT_APP_ENV === 'production' &&
  InterWebviewBridge.getInstance().getEnvironment() === WbEnvironments.BROWSER
